import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Clock, Cpu, HeartPulse, Zap } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-gold-400" data-id="element-166" />,
    title: 'Las Reglas del Juego Primordial',
    desc: 'Por qué pactaste tus crisis actuales y cómo usarlas a tu favor.'
  }, {
    icon: <Clock className="w-6 h-6 text-gold-400" data-id="element-167" />,
    title: 'La Salida del Espiral del Tiempo',
    desc: 'Cómo recuperar tu energía vital y dejar de vivir en bucles temporales.'
  }, {
    icon: <Cpu className="w-6 h-6 text-gold-400" data-id="element-168" />,
    title: 'El Algoritmo O→A→S',
    desc: 'El manual paso a paso para hackear tu percepción en tiempo real.'
  }, {
    icon: <HeartPulse className="w-6 h-6 text-gold-400" data-id="element-169" />,
    title: 'La Brújula del Cuerpo',
    desc: 'Cómo descodificar la ira, la decepción y el orgullo que se manifiestan como enfermedad.'
  }, {
    icon: <Zap className="w-6 h-6 text-gold-400" data-id="element-170" />,
    title: 'Inteligencia Emocional Cuántica',
    desc: 'La técnica para moverte rápido a través del dolor y regresar a la felicidad incondicional.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 border-y border-white/5" data-id="element-171">
      <div className="max-w-6xl mx-auto" data-id="element-172">
        <FadeIn data-id="element-173">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16 text-white" data-id="element-174">
            Lo que <span className="text-gold-400" data-id="element-175">recibes</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-176">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={`relative group ${index === items.length - 1 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-177">
              <div className="h-full p-8 rounded-xl bg-navy-900/40 border border-gold-500/10 hover:border-gold-500/30 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_-15px_rgba(201,168,76,0.2)]" data-id="element-178">
                <div className="w-12 h-12 rounded-lg bg-navy-950 border border-gold-500/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-179">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-180">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-181">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}